import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var ProductFreezeLogs = function (_super) {
  __extends(ProductFreezeLogs, _super);

  function ProductFreezeLogs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.columns = [{
      title: _this.t('冻结状态'),
      dataIndex: 'status_to_text',
      filterEmpty: true
    }, {
      title: _this.t('操作原因'),
      dataIndex: 'log_content',
      filterEmpty: true
    }, {
      title: _this.t('操作时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    return _this;
  }

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], ProductFreezeLogs.prototype, "data", void 0);

  ProductFreezeLogs = __decorate([Component], ProductFreezeLogs);
  return ProductFreezeLogs;
}(Vue);

export default ProductFreezeLogs;